export default __webpack_public_path__ + "static/media/authorape.ccf00662.png";